import type {
  AddContactCompanyMemberInput,
  RemoveContactCompanyMemberInput,
  UpdateContactCompanyMemberRoleInput,
} from 'hooks/contacts/useContactCompanies'
import type { ContactCompanyMembershipSelection } from './contactCompanyMembership'

export interface ApplyContactCompanyMembershipsInput {
  contactId: string
  toAdd: ContactCompanyMembershipSelection[]
  toRemove: string[]
  toUpdateRole: ContactCompanyMembershipSelection[]
}

export async function applyContactCompanyMemberships(
  input: ApplyContactCompanyMembershipsInput,
  handlers: {
    addCompanyMember: (input: AddContactCompanyMemberInput) => Promise<unknown>
    removeCompanyMember: (input: RemoveContactCompanyMemberInput) => Promise<unknown>
    updateCompanyMemberRole: (input: UpdateContactCompanyMemberRoleInput) => Promise<unknown>
  },
): Promise<void> {
  const contactId = input.contactId.trim()
  if (!contactId) return

  await Promise.all([
    ...input.toRemove.map((companyId) =>
      handlers.removeCompanyMember({ companyId, contactId }),
    ),
    ...input.toAdd.map(({ companyId, role }) =>
      handlers.addCompanyMember({ companyId, contactId, role }),
    ),
    ...input.toUpdateRole.map(({ companyId, role }) =>
      handlers.updateCompanyMemberRole({ companyId, contactId, role }),
    ),
  ])
}
